import { GET_MUNICIPALITIES, ERROR_MUNICIPALITIES } from "../actions/types";

const initialState = {
  municipalities: [],
  loading: true,
  error: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MUNICIPALITIES:
      return {
        ...state,
        municipalities: payload,
        loading: false,
      };
    case ERROR_MUNICIPALITIES:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};
